import { createGlobalStyle } from 'styled-components';

import { TThemeProperties } from '../theme';

export const GlobalStyle = createGlobalStyle<TThemeProperties>`
    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }

    html {
        font-size: 62.5%;
    }

    html,
    body {
        width: 100%;
        height: 100%;
    }

    body {
        margin: 0;
        padding: 0;
        color: ${properties => properties.theme.color.indigo};
        font-size: 1.6rem;
        font-family: ${properties => properties.theme.font.family.primary};
        line-height: 1.5;
    }

    abbr {
        text-decoration: none;
    }

    button {
        font-family: ${properties => properties.theme.font.family.primary};
    }
`;
